import { render, staticRenderFns } from "./TopRanking.vue?vue&type=template&id=327b35d6&scoped=true"
import script from "./TopRanking.vue?vue&type=script&lang=js"
export * from "./TopRanking.vue?vue&type=script&lang=js"
import style0 from "./TopRanking.vue?vue&type=style&index=0&id=327b35d6&prod&lang=css"
import style1 from "./TopRanking.vue?vue&type=style&index=1&id=327b35d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327b35d6",
  null
  
)

export default component.exports